import * as React from 'react';
import type { DefaultValidKeyCodesT } from '@mentimeter/hotkeys';
import type { ControlActionT } from '@mentimeter/question-modules-types';
import { Box } from '@mentimeter/ragnar-ui/box';
import { ActionButton } from '@mentimeter/slides-presentation-ui/controls/action-button';
import { Hotkey } from '../../misc/hotkeys/Hotkey';
import { useConfig, useTranslate } from '../../data-mediation';

interface SlideControlsButtonProps {
  action: ControlActionT;
  success?: boolean;
  successText?: string;
  slideId?: string;
  displayControl?: boolean;
}

export const SlideControlsButton = ({
  action,
  displayControl = true,
  ...props
}: SlideControlsButtonProps) => {
  const { onHotkey, hotkeys = [], conflictingKeys } = action;
  const translate = useTranslate();
  const { enableHotkeys } = useConfig();

  return (
    <>
      {onHotkey &&
        hotkeys.map((key: DefaultValidKeyCodesT) => (
          <Hotkey
            key={key}
            keyCode={key}
            preventDefault
            conflictingKeys={conflictingKeys}
            action={onHotkey}
          />
        ))}
      {displayControl && (
        <Box
          justifyContent="center"
          flexDirection="row"
          mt="space2"
          mx="space1"
        >
          <Box
            display="inline-flex"
            flexDirection="row"
            justifyContent="center" // Space for indications
          >
            <ActionButton
              key={action.id}
              {...props}
              id={action.id}
              children={action.children}
              hotkey={action.hotkey}
              onClick={action.onClick}
              isLoading={!!action.isLoading}
              icon={action.icon}
              translationFn={translate}
              enableHotkeys={enableHotkeys}
            />
          </Box>
        </Box>
      )}
    </>
  );
};
